import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DocIcon } from './DocIcon';
import { formatEntryMeta } from './entryMeta';

// Flat list row (design: "Häufig aufgerufen" / search results)
export const EntryListItem = ({ entry, onClick }) => {
  const { t } = useTranslation();

  return (
    <Box
      component="button"
      onClick={onClick}
      className="flex items-center cursor-pointer text-left"
      sx={{
        gap: '10px',
        border: 'none',
        background: 'transparent',
        borderRadius: '8px',
        padding: '8px 10px',
        fontFamily: 'inherit',
        color: 'var(--text)',
        fontSize: '13px',
        fontWeight: 500,
        ':hover': { background: 'var(--panel2)' },
      }}
    >
      <DocIcon
        name={entry.contentType === 'video' ? 'play_circle' : entry.icon}
        size={17}
        color="var(--text2)"
      />
      <Box component="span" className="flex-1">
        {entry.title}
      </Box>
      <Box
        component="span"
        className="whitespace-nowrap"
        sx={{ fontSize: '11px', color: 'var(--text2)' }}
      >
        {formatEntryMeta(entry, t)}
      </Box>
    </Box>
  );
};
